// src/hooks/useAuthClaims.js
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { tokenStore } from "../services/tokenStore";
import { decodeJwt } from "../services/jwt";

const emptyClaims = { userId: null, role: null, userName: null };

// чистая функция: можно использовать в любом месте, в том числе вне React
export function getAuthClaims() {
  const token = tokenStore.get();
  if (!token) return emptyClaims;

  const claims = decodeJwt(token);
  if (!claims) return emptyClaims;

  return {
    userId: claims.userId || null,
    role: claims.role || null,
    userName: claims.userName || null,
  };
}

export function getCurrentUserId() {
  const { userId } = getAuthClaims();
  return userId ? String(userId) : null;
}

// хук, если хочется использовать именно use* внутри компонентов
export function useAuthClaims() {
  const { isResolved, isLoggedIn, user, userRole } = useSelector((state) => state.auth);
  return useMemo(() => {
    if (!isResolved || !isLoggedIn) return emptyClaims;
    return {
      userId: user?.id ?? null,
      role: user?.role ?? userRole ?? null,
      userName: user?.userName ?? null,
    };
  }, [isResolved, isLoggedIn, user, userRole]);
}

export function useCurrentUserId() {
  const { userId } = useAuthClaims();
  return userId == null ? null : String(userId);
}

// Changes only at session boundaries, not during access-token rotation.
export function useAuthScope() {
  return useSelector(({ auth }) => {
    if (!auth.isResolved) return "pending";
    const viewer = auth.isLoggedIn ? auth.user?.id ?? "authenticated" : "anonymous";
    return `${viewer}:${auth.sessionVersion ?? 0}`;
  });
}
